import React from 'react';
import { Box, Modal, Card, CardContent, CardHeader, Stack, Button, TextField } from '@mui/material';
import { useParameterizedQuery } from 'react-fetching-library';
import { createTransactionAction } from '../../../services/request';
import toast from 'react-hot-toast';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
};


const PaySpecificAmountModal = ({ open, handleClose, order, orderQuery }) => {
  const [amount, setAmount] = React.useState('');
  const { query } = useParameterizedQuery(createTransactionAction);

  const handleClick = async () => {
    if (amount !== '') {
      const data = {
        order_id: order.id,
        to_pay: amount,
        contract_number: order.agreement_number === '' ? null : order.agreement_number,
        email: order.guardian_correspondence_email,
        name: order.guardian_name,
        purchaser_id: order.guardian,
        participant: order.participant_name
      };
      const params = new URLSearchParams(data).toString();
      const { payload, error, loading } = await query(params);
      if (!error && !loading) {
        window.open(payload.url, '_blank');
        setAmount('');
        handleClose();
        orderQuery();
      }

      if (error) {
        toast.error('Wystąpił błąd');
      }
    }
  };

  const handleChange = e => setAmount(e.target.value);

  return (<Modal
    open={open}
    onClose={handleClose}
  >
    <Card sx={{ ...style }}>
      <CardHeader title="Zapłać konretną kwotę"/>
      <CardContent sx={{ width: '400px' }}>
        <TextField
          label={'Kwota (zł)'}
          fullWidth
          type="number"
          onChange={handleChange}
          value={amount}
        />
        <Box height={40} />
        <Stack flexDirection="row" justifyContent="space-around">
          <Button sx={{ flexGrow: 0.4 }} variant="outlined" onClick={handleClose}>Anuluj</Button>
          <Button sx={{ flexGrow: 0.4 }} variant="contained" onClick={handleClick} disabled={Number(amount) > order.left_to_pay || amount === ''}>Zapłać</Button>
        </Stack>
      </CardContent>
    </Card>
  </Modal>);
};

export default PaySpecificAmountModal;
